import { Dispatch } from "redux";
import { BundleAssignmentProcess } from "../../api/process";
import {
    PasoDevolucion,
    ResultadoRevision,
    Armador,
} from "../../interfaces";
import { BundleAssignmentTypes } from "../types";

const dashboardPayload = (response: {
    inventario: unknown[];
    lotes: unknown[];
    armadores: Armador[];
    revisiones: Record<string, Record<string, ResultadoRevision>>;
    devoluciones: Record<string, Record<string, PasoDevolucion>>;
}) => ({
    inventario: response.inventario,
    lotes: response.lotes,
    armadores: response.armadores,
    revisiones: response.revisiones,
    devoluciones: response.devoluciones,
    loading: false,
    success: true,
});

export const getBundleAssignmentDashboardAction = () => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: BundleAssignmentTypes.GET_DASHBOARD_LOADING,
            payload: { loading: true },
        });

        const process = new BundleAssignmentProcess();
        const response = await process.getDashboard();

        return dispatch({
            type: BundleAssignmentTypes.GET_DASHBOARD_SUCCESS,
            payload: dashboardPayload(response),
        });
    } catch (error) {
        return dispatch({
            type: BundleAssignmentTypes.GET_DASHBOARD_FAILURE,
            payload: { loading: false, success: false },
        });
    }
};

export const createBundleAction = (botaIds: string[], armador: string) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: BundleAssignmentTypes.CREATE_LOTE_LOADING,
            payload: { loading: true },
        });

        const process = new BundleAssignmentProcess();
        const response = await process.createLote({ botaIds, armador });

        return dispatch({
            type: BundleAssignmentTypes.CREATE_LOTE_SUCCESS,
            payload: dashboardPayload(response),
        });
    } catch (error) {
        return dispatch({
            type: BundleAssignmentTypes.CREATE_LOTE_FAILURE,
            payload: { loading: false, success: false },
        });
    }
};

export const submitBootReviewAction = (
    loteId: string,
    botaId: string,
    resultado: ResultadoRevision,
    pasoDevolucion?: PasoDevolucion
) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: BundleAssignmentTypes.SUBMIT_REVISION_LOADING,
            payload: { loading: true },
        });

        const process = new BundleAssignmentProcess();
        const response = await process.submitRevision(loteId, {
            botaId,
            resultado,
            pasoDevolucion,
        });

        return dispatch({
            type: BundleAssignmentTypes.SUBMIT_REVISION_SUCCESS,
            payload: dashboardPayload(response),
        });
    } catch (error) {
        return dispatch({
            type: BundleAssignmentTypes.SUBMIT_REVISION_FAILURE,
            payload: { loading: false, success: false },
        });
    }
};

export const approveBundleAction = (
    loteId: string,
    revisiones: Record<string, ResultadoRevision>
) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: BundleAssignmentTypes.APPROVE_LOTE_LOADING,
            payload: { loading: true },
        });

        const process = new BundleAssignmentProcess();
        const response = await process.approveLote(loteId, { revisiones });

        return dispatch({
            type: BundleAssignmentTypes.APPROVE_LOTE_SUCCESS,
            payload: dashboardPayload(response),
        });
    } catch (error) {
        return dispatch({
            type: BundleAssignmentTypes.APPROVE_LOTE_FAILURE,
            payload: { loading: false, success: false },
        });
    }
};

export const setSelectedLoteAction = (selectedLoteId: string | null) => (dispatch: Dispatch) =>
    dispatch({
        type: BundleAssignmentTypes.SET_SELECTED_LOTE,
        payload: { selectedLoteId },
    });
